/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import EditableBtn from 'components/lib/EditableBtn';
import { useContext } from 'react';
import { unlockInteraction } from 'services/unlockInteraction';
import { FiveStarRatingContext } from './FiveStarRating_v2';
import { interactionContext } from './interactionContext';

const myFeedbackApp = ({ key, rating, message, identity, reference }) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  //
  const raw = JSON.stringify({
    key,
    response: {
      content: message,
      rating,
      identity,
      reference,
    },
  });

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const endPoint =
    window.top['collectResponseEndpoint'] ||
    'https://collect.chameleoncreator.com/api/v1/responses/create';

  if (!(window as any).hosted) {
    fetch(endPoint, requestOptions)
      .then(response => {
        return response.text();
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }
};

const SubmitBtn = props => {
  const context = useContext(interactionContext)!;
  const {
    hasLearnerIdentity,
    learnerIdentity,
    rating,
    message,
    alertLearnerIdentity,
    onSubmit,
  } = useContext(FiveStarRatingContext)!;

  const {
    useMyFeedbackApp,
    emailRequired,
    reference = '',
    collectionKey = '',
    submissionEmailDestination,
    subject,
    includeMessageText = true,
  } = context.props;

  const submitted = unlockInteraction(context.id, 1);

  let enabled = includeMessageText === false || message !== '';

  if (useMyFeedbackApp && emailRequired) {
    if (includeMessageText) {
      enabled = hasLearnerIdentity && message !== '';
    } else {
      enabled = hasLearnerIdentity;
    }
  }

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        ${!window.dev() &&
          `
            opacity: ${enabled ? 1 : 0.25};
            pointer-events: ${enabled ? 'auto' : 'none'};
            transition: opacity 0.5s;
        `}
      `}
    >
      <EditableBtn
        onClick={() => {
          onSubmit();
          if (!!useMyFeedbackApp) {
            myFeedbackApp({
              key: collectionKey,
              rating: rating + 1,
              message,
              identity: learnerIdentity,
              reference,
            });

            submitted(1);
            return;
          }

          const parsedMessage = `Rating: ${
            rating !== null ? rating + 1 : 'not rated'
          }\r\n\r\n${message}`;

          location.href = `mailto:${submissionEmailDestination}?${subject &&
            `subject=${encodeURIComponent(subject)}&`}body=${encodeURIComponent(
            parsedMessage
          )}`;

          submitted(1);
        }}
        enabled={enabled}
        {...props}
      />
    </div>
  );
};

export default SubmitBtn;
